import { render, staticRenderFns } from "./RenderScene.vue?vue&type=template&id=127861dc&scoped=true&"
import script from "./RenderScene.vue?vue&type=script&lang=js&"
export * from "./RenderScene.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127861dc",
  null
  
)

export default component.exports